import type { ApolloCache, DocumentNode } from '@apollo/client';

export function readEntityCacheFragmentById({
  cache,
  fragment,
  fragmentName,
  selector,
}: {
  cache: ApolloCache<any>;
  fragment: DocumentNode;
  fragmentName: string;
  selector: { id?: string; __typename?: string; [key: string]: any };
}) {
  return cache.readFragment({
    id: cache.identify(selector),
    fragmentName,
    fragment,
    optimistic: true,
    returnPartialData: true,
  });
}
